import React, { useEffect, useState } from 'react';
import { Form } from 'antd';
import { useQuery } from 'react-query';

import DefaultContainer from '../../../components/DefaultContainer/DefaultContainer';
import HeaderPage from '../../../components/HeaderPage/HeaderPage';
import { Member } from '../../../components/Member/Member';
import Modal from '../../../components/Modal/Modal';
import Button from '../../../components/Button/Button';

import { editUserInClub, getClubMember } from '../../../service/clubs';
import { useUserStore } from '../../../store/useUser';
import { main_color_50 } from '../../../styles/_variables';
import { getClubIdByPathname, getFormattedClubName, sortMembersByCriteria } from '../../../utils/club';
import useHeader from '../../../hooks/useHeader';

import styles from './ManagerMemberList.module.scss';
import { useParams } from 'react-router-dom';
import { ClubUser, userClubActions } from '../../../models/clubUser';
import { createErrorNotification, createSuccessNotification } from '../../../service/notification';

interface SelectActionModalProps {
  clubUser: ClubUser
  editUser?: (action: userClubActions, memberId: number) => void;
}
const SelectActionModal = ({ clubUser, editUser }: SelectActionModalProps) => {
  const menu = []

  if(!clubUser.isMediator) {
    menu.push({
      content: 'Elevar a mediador do clube',
      onClick: () => editUser('addUserAsMediator', clubUser.userId),
    })
  } else{
    menu.push({
      content: 'Remover membro da mediação',
      onClick: () => editUser('acceptUserInClub', clubUser.userId),
    })
  }

  menu.push(...[
    {
      content: 'Expulsar do clube',
      onClick: () => editUser('kickedOutUser', clubUser.userId),
    },
    {
      content: 'Aceitar no clube',
      onClick: () => editUser('acceptUserInClub', clubUser.userId),
    }
  ])

  return (
    <Form layout="vertical">
      <h1>O que você deseja editar no membro</h1>
      {
        menu.map(menu => (
          <>
            <Button
              className={styles.selectionActionButton}
              type="primary"
              onClick={(ev) => {
                ev.preventDefault();
                ev.stopPropagation();
                menu.onClick()
              }}>
              <h1>{menu.content || '+'}</h1>
            </Button>
          </>
        )
        )}
    </Form>
  )
}


const EditMemberList: React.FC = () => {
  const { id, name: clubName } = useParams();

  const [selectedUser, setSelectedUser] = useState<ClubUser | null>(null);

  const club = useUserStore(state => state.club)
  const profile = useUserStore(state => state.profile)

  const clubId = Number(id);

  const userIsAdmin = useUserStore(state => state.userIsAdmin)(clubId)
  const userIsMediator = useUserStore(state => state.userIsMediator)(clubId)

  const {data:members, refetch, isFetching} = useQuery(
    ['members', 'club', clubId],
    () => getClubMember(clubId),
    {refetchOnMount: 'always', staleTime: 0, refetchOnWindowFocus: false},
  );

  useHeader({ header: getFormattedClubName(), subheader: 'Manutenção de Membros' });

  const handleUpdateUser = async (action: userClubActions, memberId: number) => {
    const { success, error } = await editUserInClub(memberId, clubId, action)

    if (error) {
      createErrorNotification("Ops. Parece que algo não ocorreu bem, tente depois ou entre em contato")
    }

    if (success) {
      refetch && refetch()
      createSuccessNotification("Usuário foi atualizado com sucesso.")
    }
    
    return
  }

  if (profile === 'Clubista') return <DefaultContainer>Você não tem permissão pra vê essa página</DefaultContainer>
  if (club?.id !== clubId) return <DefaultContainer>Você não tem permissão pra vê essa página</DefaultContainer>
  if(!(userIsAdmin || userIsMediator)) return <DefaultContainer>Você não tem permissão pra vê essa página</DefaultContainer>
  
  return (
    <div>
      <HeaderPage header="Manutenção de Membros" bageColor={main_color_50} />
      <div className={styles.clubsContainer}>
        {sortMembersByCriteria(members || [])?.map(member => 
          <Modal
            renderToggle={({setOpen}) => <Member
              refetch={refetch}
              member={member}
              key={member.id}
              onClick={(user) => {
                setSelectedUser(user)
                setOpen(true)
              }}
              editable={!member?.isCreator}
            />}
          >
            {({ toggleModal }) =>
              <SelectActionModal
                clubUser={selectedUser}
                editUser={(...args) => {
                  handleUpdateUser(...args)
                  toggleModal()
                }}
              />
            }
          </Modal>
          )}
      </div>
    </div>
  )
}

export default EditMemberList;